export default "__VITE_ASSET__CSvZDtH6__"